export default __webpack_public_path__ + "45002bf2a26106ebf795f315ab22930a.svg";